/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import reducer from './Attribution-Reducer';
import * as attributionOperations from './Attribution-Operation';

const attributionWatcherSagas = [
    ...attributionOperations.watchers,
];

export {
    attributionWatcherSagas,
};

export default reducer;
